import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import PropTypes from 'prop-types';
import { join } from 'path';
import entityComposition from '../common/classes/entityComposition';
import EditorComponent from '../editor/editorComponent';
import notificationConstants from '../../constants/notificationConstants';

// must be defined outside of the component to avoid re-rendering loops
const defaultOnSave = () => {};
const defaultOnValidate = () => {};
const defaultOperationComplete = () => {};
const defaultOperationPending = () => {};
const FormModal = ({
  formModal: {
    active: _active = null,
    onSave: _onSave = defaultOnSave,
    // a function that saves the content
    // a function that returns an error message if the content is invalid
    onValidate: _onValidate = defaultOnValidate,
    open: _open = false,
    saveTitle: _saveTitle = 'Save',
    // The title to be displayed on the save button
    size,
    title: _title = '' // The title to be displayed on the modal
  } = {},
  formModalActions: {
    change,
    close
  },
  notificationActions: {
    validationError,
    dismiss
  }
}) => {
  if (!_active) return null;
  const {
    id,
    format
  } = _active;
  const handleChange = ({
    path,
    value,
    changeModifiers
  }) => {
    change(id, join('content', path), value, changeModifiers);
  };
  const handleClose = () => {
    close();
  };
  const handleSave = async () => {
    // run validation behaviors
    if (_onValidate) {
      const validationResult = await _onValidate(_active.content);
      if (validationResult) {
        // display validation errors
        validationError({
          list: [validationResult],
          id: notificationConstants.VALIDATION_ERROR
        }, {
          autoClose: 10000
        });
        return;
      }
    }
    dismiss(notificationConstants.VALIDATION_ERROR); // remove validation-error notification

    // if validation passes, run save actions
    await _onSave(_active.content);
    close();
  };
  return /*#__PURE__*/React.createElement(Modal, {
    isOpen: _open,
    size: size
  }, /*#__PURE__*/React.createElement(ModalHeader, null, _title), /*#__PURE__*/React.createElement(ModalBody, null, /*#__PURE__*/React.createElement(EditorComponent, {
    reduxEntity: "formModal",
    path: "/",
    format: format,
    onChange: handleChange,
    operationComplete: defaultOperationComplete,
    operationPending: defaultOperationPending
  })), /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement(Button, {
    onClick: handleSave,
    className: "t-fm-save"
  }, _saveTitle), /*#__PURE__*/React.createElement(Button, {
    onClick: handleClose,
    className: "t-fm-cancel"
  }, "Close")));
};
FormModal.propTypes = {
  formModal: PropTypes.shape({
    active: PropTypes.shape({}),
    onSave: PropTypes.func,
    onValidate: PropTypes.func,
    open: PropTypes.bool,
    saveTitle: PropTypes.string,
    size: PropTypes.string,
    title: PropTypes.string
  }),
  formModalActions: PropTypes.shape({
    change: PropTypes.func.isRequired,
    close: PropTypes.func.isRequired
  }).isRequired,
  notificationActions: PropTypes.shape({
    validationError: PropTypes.func,
    dismiss: PropTypes.func
  }).isRequired
};
export { FormModal as TestFormModal };
export default entityComposition(FormModal, ['formModal'], {}, ['notification']);